import {
    ADD_SINGLE_TARGET_MAINTENANCE_STEP,
    ADD_TARGET_MAINTENANCE_STEP,
    CHANGE_GOAL_MASTERY,
    CHANGE_MAINTENANCE_STEP,
    CHANGE_SINGLE_TARGET_MAINTENANCE,
    CHANGE_SINGLE_TARGET_MASTERY,
    CHANGE_TARGET_MAINTENANCE,
    CHANGE_TARGET_MASTERY,
    CHOOSE_GOALS_FROM_LIBRARY,
    CHOOSE_OPTIONS_FROM_LIBRARY,
    CHOOSE_TARGETS_FROM_LIBRARY,
    CLONE_GOAL,
    CREATE_GOAL,
    CREATE_OPTION,
    CREATE_TARGET,
    CREATE_SECTION_TYPE,
    DELETE_GOAL,
    RESTORE_GOAL,
    RESTORE_OPTION,
    UPSERT_SECTION_DESCRIPTION_BLOCK,
    DELETE_SECTION_DESCRIPTION_BLOCK,
    REORDER_SECTION_DESCRIPTION_BLOCKS,
    DELETE_OPTION,
    DELETE_SINGLE_TARGET_MAINTENANCE_STEP,
    DELETE_TARGET_MAINTENANCE_STEP,
    EDIT_GOAL,
    EDIT_GOAL_STATUS,
    EDIT_OPTION,
    EDIT_SECTION_TYPE,
    EDIT_SINGLE_TARGET_MAINTENANCE_STEP,
    EDIT_TARGET,
    EDIT_TARGET_TRANSITION_DATE,
    EDIT_TARGET_MAINTENANCE_STEP,
    GET_GOAL_BY_ID,
    GET_SECTION_TYPES,
    GET_GOAL_GRAPH,
    GET_GOAL_SESSIONS,
    GET_GOAL_TRIAL_DATA,
    GET_GOALS,
    GET_GOALS_FOR_SESSION,
    GET_TARGET_CHART_DATA,
    REMOVE_SINGLE_TARGET_MASTERY,
    CHANGE_BASELINE_CRITERIA,
    CHANGE_SINGLE_TARGET_BASELINE_CRITERIA,
    SINGLE_TARGET_BASELINE_FOLLOW_GOAL,
    REMOVE_SINGLE_TARGET_BASELINE_CRITERIA,
    REORDER_OPTION,
    REORDER_TARGET,
    SINGLE_TARGET_FOLLOW_GOAL_CONFIG,
    SINGLE_TARGET_MASTERY_FOLLOW_GOAL,
    GET_SIMPLE_GOALS,
    GET_GOAL_CLINICAL_DATA,
    GET_GOAL_CLINICAL_DEFAULT_VALUES,
    GET_GOAL_TARGET_CLINICAL_DATA,
} from './goal.types';

/** Goals */

export const getGoals = (params, load) => {
    return {
        type: GET_GOALS,
        payload: { params, load },
    };
};

/** Goals with Teaching / Baseline targets. `params`: manual entry's `manualGoalsQuery` (the edited session). */
export const getGoalsForSession = (clientId, load, params) => {
    return {
        type: GET_GOALS_FOR_SESSION,
        payload: { clientId, load, params },
    };
};
export const getSimpleGoals = (clientId, params, load) => {
    return {
        type: GET_SIMPLE_GOALS,
        payload: { clientId, params, load },
    };
};

export const chooseGoalsFromLibrary = (body, requestParams) => {
    return {
        type: CHOOSE_GOALS_FROM_LIBRARY,
        payload: { body, requestParams },
    };
};
export const chooseTargetsFromLibrary = (goalId, body) => {
    return {
        type: CHOOSE_TARGETS_FROM_LIBRARY,
        payload: { goalId, body },
    };
};

export const chooseOptionsFromLibrary = (goalId, body) => {
    return {
        type: CHOOSE_OPTIONS_FROM_LIBRARY,
        payload: { goalId, body },
    };
};

export const getGoalById = (id, load) => {
    return {
        type: GET_GOAL_BY_ID,
        payload: { id, load },
    };
};

export const getSectionTypes = (load) => {
    return {
        type: GET_SECTION_TYPES,
        payload: { load },
    };
};

export const createSectionType = (body) => {
    return {
        type: CREATE_SECTION_TYPE,
        payload: { body },
    };
};

export const editSectionType = (id, body) => {
    return {
        type: EDIT_SECTION_TYPE,
        payload: { id, body },
    };
};

export const createGoal = (body, requestParams) => {
    return {
        type: CREATE_GOAL,
        payload: { body, requestParams },
    };
};

export const editGoal = (id, body, requestParams) => {
    return {
        type: EDIT_GOAL,
        payload: { id, body, requestParams },
    };
};
export const upsertSectionDescriptionBlock = (goalId, body, requestParams) => {
    return {
        type: UPSERT_SECTION_DESCRIPTION_BLOCK,
        payload: { goalId, body, requestParams },
    };
};
export const deleteSectionDescriptionBlock = (goalId, sectionTypeId, requestParams) => {
    return {
        type: DELETE_SECTION_DESCRIPTION_BLOCK,
        payload: { goalId, sectionTypeId, requestParams },
    };
};
export const reorderSectionDescriptionBlocks = (goal, reorder) => {
    return {
        type: REORDER_SECTION_DESCRIPTION_BLOCKS,
        payload: { goal, reorder },
    };
};
export const editGoalStatus = (id, status, requestParams) => {
    return {
        type: EDIT_GOAL_STATUS,
        payload: { id, status, requestParams },
    };
};

export const deleteGoal = (id, requestParams) => {
    return {
        type: DELETE_GOAL,
        payload: { id, requestParams },
    };
};

export const restoreGoal = (id, requestParams) => {
    return {
        type: RESTORE_GOAL,
        payload: { id, requestParams },
    };
};

export const cloneGoal = (id, data, requestParams) => {
    return {
        type: CLONE_GOAL,
        payload: { id, data, requestParams },
    };
};
export const getGoalSessions = (goalId, load) => {
    return {
        type: GET_GOAL_SESSIONS,
        payload: { goalId, load },
    };
};
export const getGoalGraph = (goalId, params) => {
    return {
        type: GET_GOAL_GRAPH,
        payload: { goalId, params },
    };
};
export const getGoalTrialData = (goalId, sessionId) => {
    return {
        type: GET_GOAL_TRIAL_DATA,
        payload: { goalId, sessionId },
    };
};

/** End */

/** Targets */
export const createTarget = (goalId, body, requestParams) => {
    return {
        type: CREATE_TARGET,
        payload: { goalId, body, requestParams },
    };
};
export const editTarget = (goalId, targetId, body, requestParams) => {
    return {
        type: EDIT_TARGET,
        payload: { goalId, targetId, body, requestParams },
    };
};
export const editTargetTransitionDate = (goalId, targetId, date, requestParams) => {
    return {
        type: EDIT_TARGET_TRANSITION_DATE,
        payload: { goalId, targetId, date, requestParams },
    };
};
export const reorderTarget = (goal, reorder) => {
    return {
        type: REORDER_TARGET,
        payload: { goal, reorder },
    };
};
export const getTargetChartData = (clientId, params) => {
    return {
        type: GET_TARGET_CHART_DATA,
        payload: { clientId, params },
    };
};

/** End */

/** Options */
export const createOption = (goalId, body) => {
    return {
        type: CREATE_OPTION,
        payload: { goalId, body },
    };
};
export const editOption = (goalId, optionId, body) => {
    return {
        type: EDIT_OPTION,
        payload: { goalId, optionId, body },
    };
};
export const deleteOption = (goalId, optionId) => {
    return {
        type: DELETE_OPTION,
        payload: { goalId, optionId },
    };
};
export const restoreOption = (goalId, optionId) => {
    return {
        type: RESTORE_OPTION,
        payload: { goalId, optionId },
    };
};
export const reorderOption = (goal, reorder) => {
    return {
        type: REORDER_OPTION,
        payload: { goal, reorder },
    };
};

/** End */

/** Mastery */
export const changeTargetMastery = (goalId, body) => {
    return {
        type: CHANGE_TARGET_MASTERY,
        payload: { goalId, body },
    };
};
export const changeGoalMastery = (goalId, body) => {
    return {
        type: CHANGE_GOAL_MASTERY,
        payload: { goalId, body },
    };
};
export const changeSingleTargetMastery = (goalId, targetId, body) => {
    return {
        type: CHANGE_SINGLE_TARGET_MASTERY,
        payload: { goalId, targetId, body },
    };
};
export const singleTargetMasteryFollowGoal = (goalId, targetId, body) => {
    return {
        type: SINGLE_TARGET_MASTERY_FOLLOW_GOAL,
        payload: { goalId, targetId, body },
    };
};

export const removeSingleTargetMastery = (goalId, targetId) => {
    return {
        type: REMOVE_SINGLE_TARGET_MASTERY,
        payload: { goalId, targetId },
    };
};

/** Baseline -> Teaching criteria */
export const changeBaselineCriteria = (goalId, body) => {
    return {
        type: CHANGE_BASELINE_CRITERIA,
        payload: { goalId, body },
    };
};

export const changeSingleTargetBaselineCriteria = (goalId, targetId, body) => {
    return {
        type: CHANGE_SINGLE_TARGET_BASELINE_CRITERIA,
        payload: { goalId, targetId, body },
    };
};

export const singleTargetBaselineFollowGoal = (goalId, targetId, body) => {
    return {
        type: SINGLE_TARGET_BASELINE_FOLLOW_GOAL,
        payload: { goalId, targetId, body },
    };
};

export const removeSingleTargetBaselineCriteria = (goalId, targetId) => {
    return {
        type: REMOVE_SINGLE_TARGET_BASELINE_CRITERIA,
        payload: { goalId, targetId },
    };
};

export const changeSingleTargetMaintenance = (goalId, targetId, body) => {
    return {
        type: CHANGE_SINGLE_TARGET_MAINTENANCE,
        payload: { goalId, targetId, body },
    };
};
export const addSingleTargetMaintenanceStep = (goalId, targetId, body) => {
    return {
        type: ADD_SINGLE_TARGET_MAINTENANCE_STEP,
        payload: { goalId, targetId, body },
    };
};
export const editSingleTargetMaintenanceStep = (goalId, stepId, body) => {
    return {
        type: EDIT_SINGLE_TARGET_MAINTENANCE_STEP,
        payload: { goalId, stepId, body },
    };
};
export const singleTargetFollowGoalConfig = (goalId, targetId, body) => {
    return {
        type: SINGLE_TARGET_FOLLOW_GOAL_CONFIG,
        payload: { goalId, targetId, body },
    };
};
export const deleteSingleTargetMaintenanceStep = (goalId, targetId, stepId) => {
    return {
        type: DELETE_SINGLE_TARGET_MAINTENANCE_STEP,
        payload: { goalId, targetId, stepId },
    };
};
export const changeMaintenanceStep = (goalId, params) => {
    return {
        type: CHANGE_MAINTENANCE_STEP,
        payload: { goalId, params },
    };
};
/** End */

/** Target Maintenance */
export const changeTargetMaintenance = (goalId, body) => {
    return {
        type: CHANGE_TARGET_MAINTENANCE,
        payload: { goalId, body },
    };
};
export const addTargetMaintenanceStep = (goalId, body) => {
    return {
        type: ADD_TARGET_MAINTENANCE_STEP,
        payload: { goalId, body },
    };
};
export const editTargetMaintenanceStep = (goalId, stepId, body) => {
    return {
        type: EDIT_TARGET_MAINTENANCE_STEP,
        payload: { goalId, stepId, body },
    };
};
export const deleteTargetMaintenanceStep = (goalId, stepId) => {
    return {
        type: DELETE_TARGET_MAINTENANCE_STEP,
        payload: { goalId, stepId },
    };
};
/** End */

/** Goal Clinical Data */
export const getGoalClinicalData = (params) => {
    return {
        type: GET_GOAL_CLINICAL_DATA,
        payload: { params },
    };
};
export const getGoalTargetClinicalData = (params, clientId) => {
    return {
        type: GET_GOAL_TARGET_CLINICAL_DATA,
        payload: { params, clientId },
    };
};
export const getGoalClinicalDefaultValues = (params) => {
    return {
        type: GET_GOAL_CLINICAL_DEFAULT_VALUES,
        payload: { params },
    };
};

/** End */
